function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

import { createBoundedBuffer, canUseEventBridge, display, displayAlreadyInitializedError, initFeatureFlags, initFetchObservable, noop, timeStampNow, buildAccountContextManager, CustomerContextKey, bufferContextCalls, addTelemetryConfiguration, buildGlobalContextManager, buildUserContextManager } from '@datadog/browser-core';
import { serializeLogsConfiguration, validateAndBuildLogsConfiguration } from '../domain/configuration';
export function createPreStartStrategy(getCommonContext, trackingConsentState, doStartLogs) {
  var bufferApiCalls = createBoundedBuffer(); // TODO next major: remove the globalContext, accountContextManager, userContext from preStartStrategy and use an empty context instead

  var globalContext = buildGlobalContextManager();
  bufferContextCalls(globalContext, CustomerContextKey.globalContext, bufferApiCalls);
  var accountContext = buildAccountContextManager();
  bufferContextCalls(accountContext, CustomerContextKey.accountContext, bufferApiCalls);
  var userContext = buildUserContextManager();
  bufferContextCalls(userContext, CustomerContextKey.userContext, bufferApiCalls);
  var cachedInitConfiguration;
  var cachedConfiguration;
  var trackingConsentStateSubscription = trackingConsentState.observable.subscribe(tryStartLogs);

  function tryStartLogs() {
    if (!cachedConfiguration || !cachedInitConfiguration || !trackingConsentState.isGranted()) {
      return;
    }

    trackingConsentStateSubscription.unsubscribe();
    var startLogsResult = doStartLogs(cachedInitConfiguration, cachedConfiguration);
    bufferApiCalls.drain(startLogsResult);
  }

  return {
    init: function init(initConfiguration) {
      if (!initConfiguration) {
        display.error('Missing configuration');
        return;
      } // Set the experimental feature flags as early as possible, so we can use them in most places


      initFeatureFlags(initConfiguration.enableExperimentalFeatures);

      if (canUseEventBridge()) {
        initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
      } // Expose the initial configuration regardless of initialization success.


      cachedInitConfiguration = initConfiguration;
      addTelemetryConfiguration(serializeLogsConfiguration(initConfiguration));

      if (cachedConfiguration) {
        displayAlreadyInitializedError('DD_LOGS', initConfiguration);
        return;
      }

      var configuration = validateAndBuildLogsConfiguration(initConfiguration);

      if (!configuration) {
        return;
      }

      cachedConfiguration = configuration; // Instrumuent fetch to track network requests
      // This is needed in case the consent is not granted and some cutsomer
      // library (Apollo Client) is storing uninstrumented fetch to be used later
      // The subscrption is needed so that the instrumentation process is completed

      initFetchObservable().subscribe(noop);
      trackingConsentState.tryToInit(configuration.trackingConsent);
      tryStartLogs();
    },

    get initConfiguration() {
      return cachedInitConfiguration;
    },

    globalContext: globalContext,
    accountContext: accountContext,
    userContext: userContext,
    getInternalContext: noop,
    handleLog: function handleLog(message, statusType, handlingStack) {
      var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : getCommonContext();
      var date = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : timeStampNow();
      bufferApiCalls.add(function (startLogsResult) {
        return startLogsResult.handleLog(message, statusType, handlingStack, context, date);
      });
    }
  };
}

function overrideInitConfigurationForBridge(initConfiguration) {
  return _objectSpread(_objectSpread({}, initConfiguration), {}, {
    clientToken: 'empty'
  });
}